if (!customElements.get('hoculus-thank-you-message')) {
  class HoculusThankYouMessage extends HTMLElement {
    constructor() {
      super();
      this.dataMessages = JSON.parse(this.dataset.showMessages || '{}');
      this.existingErrorParam = new URLSearchParams(window.location.search).get('error') || null;
      this.textEl = document.createElement('p');
      this.appendChild(this.textEl);
    }

    connectedCallback() {
      this.handleMessageChange();
    }

    handleMessageChange() {
      const { success, error } = this.dataMessages;
      this.textEl.textContent = this.existingErrorParam ? error : success;
    }
  }
  customElements.define('hoculus-thank-you-message', HoculusThankYouMessage);
}
